import React from 'react';
import Dropzone from 'react-dropzone';
import TextFileUploadIcon from '../Icons/TextFileUploadIcon';

interface ICustomTextFileUpload {
  onChange: (e: any) => void;
}
export default function CustomTextFileUpload({
  onChange,
}: ICustomTextFileUpload) {
  return (
    <Dropzone
      onDrop={(acceptedFiles) => onChange(acceptedFiles)}
      multiple={false}
      accept={{
        'text/plain': [],
      }}
    >
      {({ getRootProps, getInputProps }) => (
        <div
          className={
            'px-4 py-6 rounded-8 border border-dashed border-blue bg-blueLight flex flex-col items-center justify-center relative cursor-pointer'
          }
        >
          <div {...getRootProps()}>
            <input {...getInputProps()} />
            <div className={'flex flex-col items-center gap-2 text-center'}>
              <TextFileUploadIcon />
              <p className={'text-primary leading-142'}>
                Drop your file here or{' '}
                <span className={'text-blue font-semibold'}>Upload file</span>
              </p>
              <p className={'text-12 leading-1 text-[#8992A8]'}>
                Upload a .txt file with one email per line
              </p>
            </div>
          </div>
        </div>
      )}
    </Dropzone>
  );
}
